import { io } from 'socket.io-client';

const socket = io(`${process.env.REACT_APP_API_BASE_URL}`, {  // or your production URL
 
  withCredentials: true,
  transports: ['websocket']
});
window.socket = socket; 

export default socket;